/**
 * The component registry: maps the name a CakePHP view or the Hypernova SSR bridge asks
 * for (`data-component`/`data-hypernova-key` in views, or `getComponent(name)` in
 * `ssr.jsx`) to a dynamic `import()` of its module, so each feature component ships in
 * its own Vite chunk (see `vite.config.ts`) and is only fetched when actually mounted.
 * Shared by the client (`App.tsx`) and the server SSR entry (`ssr.jsx`) — add a case here
 * whenever a component needs to be mountable by name.
 *
 * Part of the V2 React App component — see docs/wiki/System/v2/frontend/v2-react-app.md.
 *
 * @param {string} name
 * @returns {Promise<React.ComponentType<any>>}
 */
export function loadComponent(name) {
    switch (name) {
        case "ChecklistHeader":
            return import("@components/checklist-page").then(i => i.Header);
        case "ChecklistPage":
            return import("@components/checklist-page").then(i => i.Page);
        case "OptOutPage":
            return import("@components/privacy/page").then(i => i.default);
        case "FormBuilder":
            return import("@components/form-builder").then(i => i.default);
        case "ContentFeedHeader":
            return import("@components/content-feed").then(i => i.Header);
        case "ContentFeed":
            return import("@components/content-feed").then(i => i.Feed);
        case "Quiz":
            return import("@components/quiz").then(i => i.default);
        case "MbForm":
            return import("@components/form-builder/mb-form").then(i => i.default);
        case "PageView":
            return import("@views/pages/view").then(i => i.default);
    }
}
